/* tslint:disable */
/* eslint-disable */
/**
 * merged spec
 * merged spec
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var AllDayActivityType;
(function (AllDayActivityType) {
    AllDayActivityType["Practice"] = "event_practice";
    AllDayActivityType["Lesson"] = "event_lesson";
    AllDayActivityType["Training"] = "event_training";
    AllDayActivityType["Meeting"] = "event_meeting";
    AllDayActivityType["Tournament"] = "event_tournament";
    AllDayActivityType["League"] = "event_league";
    AllDayActivityType["Camp"] = "event_camp";
    AllDayActivityType["Class"] = "event_class";
    AllDayActivityType["Other"] = "event_other";
})(AllDayActivityType || (AllDayActivityType = {}));
